import type { Mark } from "../shared/schema";
import {
  markPresentation,
  measurementLabel,
} from "../shared/mark-presentation";
export function MarkGlyph({ shape, meters }: { shape: Mark; meters: number }) {
  const { points: p, color, kind, weight } = shape.props;
  if (p.length < 2) return null;
  const style = markPresentation(shape),
    hatch = `h${shape.id.replace(/[^a-z0-9]/gi, "")}`,
    label = measurementLabel(shape, meters);
  return (
    <g>
      <defs>
        <pattern
          id={hatch}
          width={style.spacing}
          height={style.spacing}
          patternUnits="userSpaceOnUse"
          patternTransform={`rotate(${style.angle})`}
        >
          <line
            x1="0"
            y1="0"
            x2="0"
            y2={style.spacing}
            stroke={style.fillColor}
            opacity=".35"
          />
          {shape.meta.hatch === "cross" && (
            <line
              x1="0"
              y1="0"
              x2={style.spacing}
              y2="0"
              stroke={style.fillColor}
              opacity=".35"
            />
          )}
        </pattern>
      </defs>
      {kind === "area" ? (
        <polygon
          points={p.map((q) => `${q.x},${q.y}`).join(" ")}
          fill={
            shape.meta.hatch === "none"
              ? "none"
              : shape.meta.hatch === "solid"
                ? style.fillColor
                : `url(#${hatch})`
          }
          fillOpacity={shape.meta.hatch === "solid" ? 0.16 : 1}
          stroke={color}
          strokeWidth={weight}
          strokeDasharray={style.dash.join(" ")}
        />
      ) : (
        <polyline
          points={p.map((q) => `${q.x},${q.y}`).join(" ")}
          fill="none"
          stroke={color}
          strokeWidth={weight}
          strokeDasharray={style.dash.join(" ")}
        />
      )}
      {style.decorations.map((points, i) => (
        <polyline
          key={i}
          points={points.map((q) => `${q.x},${q.y}`).join(" ")}
          fill="none"
          stroke={color}
          strokeWidth={weight}
        />
      ))}
      {kind !== "line" && label && (
        <g transform={`translate(${style.label.x},${style.label.y})`}>
          <rect
            x={-Math.max(52, label.length * 4.5)}
            y="-14"
            width={Math.max(104, label.length * 9)}
            height="25"
            fill="white"
            opacity=".96"
          />
          <text
            textAnchor="middle"
            y="4"
            fontFamily="Inter, Arial, sans-serif"
            fontSize="15"
            fontWeight="600"
            fill={color}
          >
            {label}
          </text>
        </g>
      )}
    </g>
  );
}
